import { useEffect } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { Geolocation } from '@capacitor/geolocation';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';

import { IS_NATIVE, IS_WEB } from '../../../../../src/common/constants';

export async function hasLocationPermission(): Promise<boolean> {
  if (IS_WEB) {
    // Simulating permission grant on web
    // change to false to see location info component
    return true;
  }
  try {
    const permStatus = await Geolocation.checkPermissions();
    return permStatus.location === 'granted' || permStatus.coarseLocation === 'granted';
  } catch (err) {
    console.error('Error checking location permissions:', err);
    return false;
  }
}

export async function requestLocationPermission(): Promise<boolean> {
  try {
    if (IS_WEB) {
      // Simulating permission grant on web
      // change to false to see location required error component
      return true;
    }

    const permStatus = await Geolocation.requestPermissions();
    const granted = permStatus.location === 'granted' || permStatus.coarseLocation === 'granted';

    return granted;
  } catch (err) {
    console.error('Error requesting location permissions:', err);
    return false;
  }
}

export async function openAppSettings() {
  try {
    if (IS_NATIVE) {
      await NativeSettings.open({ optionAndroid: AndroidSettings.ApplicationDetails, optionIOS: IOSSettings.App });
    }
  } catch (err) {
    console.error('Error opening settings:', err);
  }
}
// Allow only while using the app is only that will trigger listeners
export function useAppStateWatcher(callback: () => void) {
  useEffect(() => {
    const subs = [
      CapacitorApp.addListener('resume', callback),
      CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        if (isActive) callback();
      }),
    ];

    return () => subs.forEach(async (s) => (await s).remove());
  }, [callback]);
}
